import { useEffect, useState } from 'react';
import api from '@/utils/api';

export const halloweenAPI = {
  status: () => api.get('/halloween/status'),
  ghost: (path) => api.get('/halloween/ghost', { params: { path } }),
  collect: (path) => api.post('/halloween/ghost/collect', { path }),
  scan: (path) => api.get('/halloween/scan', { params: { path } }),
  shop: () => api.get('/halloween/shop'),
  purchase: (itemId) => api.post('/halloween/shop/purchase', { item_id: itemId }),
};

export const CANDY_EVENT = 'halloween-candy';
export const GHOST_IMAGES = [1, 2, 3, 4, 5].reduce((m, n) => ({ ...m, [n]: `/halloween/ghost${n}.png` }), {});

// Season state is decided by the server, so the event turns itself off/on by date
let cache = null;
export const useHalloween = (enabled = true) => {
  const [state, setState] = useState(cache || { active: false, candy: 0 });
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    const load = () => halloweenAPI.status().then((r) => { cache = r.data; if (alive) setState(r.data); }).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    const onCandy = (e) => { cache = { ...(cache || {}), candy: e.detail }; setState((s) => ({ ...s, candy: e.detail })); };
    window.addEventListener(CANDY_EVENT, onCandy);
    return () => { alive = false; clearInterval(t); window.removeEventListener(CANDY_EVENT, onCandy); };
  }, [enabled]);
  return state;
};

export const setCandy = (n) => window.dispatchEvent(new CustomEvent(CANDY_EVENT, { detail: n }));
